<template>
  <div>
    <Modal v-model="showModal" title="编辑">
      <Alert v-if="vacForm.id" type="warning">修改教师假日时间将导致已排课程出现混乱，请注意前往修改已排课程</Alert>
      <Form :model="vacForm" :label-width="60" :rules="vacRules" ref="vacForm">
        <FormItem label="教师" prop="teacher_id">
          <Select v-model="vacForm.teacher_id"  >
            <Option v-for="(item,index) in teacherList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="时间" prop="weekday">
          <Select v-model="vacForm.weekday"   >
            <Option v-for="(item,index) in weekdayList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="类型" prop="workflag">
          <Select v-model="vacForm.workflag"   >
            <Option v-for="(item,index) in workflagList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="small" @click="saveVac('vacForm')">确认</Button>
        <Button type="default" size="small" @click="modelcancle">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name:'vaction_Form',
    data(){
      return{
        showModal:false,
        vacForm:{
          id:'',
          teacher_id:'',
          weekday:'',
          workflag:''
        },
        teacherList:[],
        weekdayList:[
          {
            id:1,
            name:'星期一'
          },
          {
            id:2,
            name:'星期二'
          },
          {
            id:3,
            name:'星期三'
          },
          {
            id:4,
            name:'星期四'
          },
          {
            id:5,
            name:'星期五'
          },
          {
            id: 6,
            name: '星期六'
          },
          {
            id:7,
            name:'星期日'
          }
        ],
        workflagList:[
          {
            id:1,
            name:'全天'
          },
          {
            id:2,
            name:'早上'
          },
          {
            id:3,
            name:'下午'
          },
          {
            id:4,
            name:'晚上'
          }
        ],
        vacRules:{
          teacher_id:[{required:true,message:'请选择教师',trigger:'change',type:'number'}],
          weekday:[{required:true,message:'请选择时间',trigger:'change',type:'number'}],
          workflag:[{required:true,message:'请选择类型',trigger:'change',type:'number'}]
        }
      }
    },
    methods:{
      getTeacherList(){
        this.teacherList=[]
        let param={
          page:1,
          size:9999
        }
        this.$api.teacher.getTeacherList(param).then(res=>{
          if(res.state=="ok"){
            this.teacherList=res.teacherList.list;
          }else{
            this.$Message.error(res.msg)
          }
        })
      },
      saveVac(name){
        let self = this
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.setting.saveVac(this.packagingFormData()).then(res=>{
              if(res.state=="ok"){
                this.$Message.success("保存成功")
                this.$emit("refresh");
              }else{
                this.$Message.error(res.msg)
              }
              this.showModal=false
            })
          }
        })
      },
      packagingFormData() {
        let postFormData = {};
        for (var i in this.vacForm) {
          if (this.vacForm.hasOwnProperty(i)) {
            postFormData['vacation.' + i] = this.vacForm[i];
          }
        }
        return postFormData;
      },
      modelcancle(){
        this.$refs.vacForm.resetFields()
        this.showModal=false
      }
    }
  }
</script>
